// SPDX-FileCopyrightText: OpenTalk GmbH <mail@opentalk.eu>
//
// SPDX-License-Identifier: EUPL-1.2

enum LayoutOptions {
  Grid = 'grid',
  Speaker = 'speaker',
  Whiteboard = 'whiteboard',
  Protocol = 'protocol',
}

export default LayoutOptions;
